'use strict';

var _extends = require('@babel/runtime/helpers/extends');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
require('react');
var _taggedTemplateLiteral = require('@babel/runtime/helpers/taggedTemplateLiteral');
var styled = require('@emotion/styled');
var parseDataAttributes = require('./parseDataAttributes-81c8dbee.js');
var react = require('@emotion/react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var _taggedTemplateLiteral__default = /*#__PURE__*/_interopDefaultLegacy(_taggedTemplateLiteral);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var _templateObject$1;
var setTextDecoration = function setTextDecoration(variant) {
  if (variant === 'link') {
    return 'underline';
  }
  return 'none';
};
var setFontWeight = function setFontWeight(variant) {
  switch (variant) {
    case 'regular':
      {
        return 400;
      }
    case 'bold':
      {
        return 700;
      }
    default:
      {
        return 400;
      }
  }
};
var Container = styled__default["default"].span(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral__default["default"](["\n    color: ", ";\n    font-family: ", ";\n    font-weight: ", ";\n    text-decoration: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors['text-global-primary'];
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fonts.family;
}, function (_ref3) {
  var variant = _ref3.variant;
  return setFontWeight(variant);
}, function (_ref4) {
  var variant = _ref4.variant;
  return setTextDecoration(variant);
});

var _excluded$1 = ["children", "className", "as", "variant", "dataAttributes", "innerRef"];
var TextContainer = function TextContainer(_ref) {
  var children = _ref.children,
    className = _ref.className,
    _ref$as = _ref.as,
    as = _ref$as === void 0 ? 'span' : _ref$as,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'regular' : _ref$variant,
    _ref$dataAttributes = _ref.dataAttributes,
    dataAttributes = _ref$dataAttributes === void 0 ? {} : _ref$dataAttributes,
    innerRef = _ref.innerRef,
    nativeProps = _objectWithoutProperties__default["default"](_ref, _excluded$1);
  return react.jsx(Container, _extends__default["default"]({}, nativeProps, parseDataAttributes.parseDataAttributes(dataAttributes), {
    ref: innerRef,
    variant: variant,
    as: as,
    className: className
  }), children);
};

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
var P1Styled = styled__default["default"](TextContainer)(_templateObject || (_templateObject = _taggedTemplateLiteral__default["default"](["\n    font-size: ", ";\n    line-height: ", ";\n    margin-block-end: unset;\n    margin-block-start: unset;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.typography.p1.fontSize;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.typography.p1.lineHeight;
});
var P2Styled = styled__default["default"](TextContainer)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral__default["default"](["\n    font-size: ", ";\n    line-height: ", ";\n    margin-block-end: unset;\n    margin-block-start: unset;\n"])), function (_ref3) {
  var theme = _ref3.theme;
  return theme.typography.p2.fontSize;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.typography.p2.lineHeight;
});
var P3Styled = styled__default["default"](TextContainer)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral__default["default"](["\n    font-size: ", ";\n    line-height: ", ";\n    margin-block-end: unset;\n    margin-block-start: unset;\n"])), function (_ref5) {
  var theme = _ref5.theme;
  return theme.typography.p3.fontSize;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.typography.p3.lineHeight;
});
var P4Styled = styled__default["default"](TextContainer)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral__default["default"](["\n    font-size: ", ";\n    line-height: ", ";\n    margin-block-end: unset;\n    margin-block-start: unset;\n"])), function (_ref7) {
  var theme = _ref7.theme;
  return theme.typography.p4.fontSize;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.typography.p4.lineHeight;
});
var P5Styled = styled__default["default"](TextContainer)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral__default["default"](["\n    font-size: ", ";\n    line-height: ", ";\n    margin-block-end: unset;\n    margin-block-start: unset;\n"])), function (_ref9) {
  var theme = _ref9.theme;
  return theme.typography.p5.fontSize;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.typography.p5.lineHeight;
});

var _excluded = ["variant", "as", "className", "dataAttributes", "innerRef", "children"],
  _excluded2 = ["variant", "as", "className", "dataAttributes", "innerRef", "children"],
  _excluded3 = ["variant", "as", "className", "dataAttributes", "innerRef", "children"],
  _excluded4 = ["variant", "as", "className", "dataAttributes", "innerRef", "children"],
  _excluded5 = ["variant", "as", "className", "dataAttributes", "innerRef", "children"];
var P1 = function P1(_ref) {
  var _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'regular' : _ref$variant,
    _ref$as = _ref.as,
    as = _ref$as === void 0 ? 'p' : _ref$as,
    className = _ref.className,
    _ref$dataAttributes = _ref.dataAttributes,
    dataAttributes = _ref$dataAttributes === void 0 ? {} : _ref$dataAttributes,
    innerRef = _ref.innerRef,
    children = _ref.children,
    nativeProps = _objectWithoutProperties__default["default"](_ref, _excluded);
  return react.jsx(P1Styled, _extends__default["default"]({}, nativeProps, {
    innerRef: innerRef,
    dataAttributes: dataAttributes,
    variant: variant,
    className: className,
    as: as
  }), children);
};
var P2 = function P2(_ref2) {
  var _ref2$variant = _ref2.variant,
    variant = _ref2$variant === void 0 ? 'regular' : _ref2$variant,
    _ref2$as = _ref2.as,
    as = _ref2$as === void 0 ? 'p' : _ref2$as,
    className = _ref2.className,
    _ref2$dataAttributes = _ref2.dataAttributes,
    dataAttributes = _ref2$dataAttributes === void 0 ? {} : _ref2$dataAttributes,
    innerRef = _ref2.innerRef,
    children = _ref2.children,
    nativeProps = _objectWithoutProperties__default["default"](_ref2, _excluded2);
  return react.jsx(P2Styled, _extends__default["default"]({}, nativeProps, {
    innerRef: innerRef,
    dataAttributes: dataAttributes,
    variant: variant,
    className: className,
    as: as
  }), children);
};
var P3 = function P3(_ref3) {
  var _ref3$variant = _ref3.variant,
    variant = _ref3$variant === void 0 ? 'regular' : _ref3$variant,
    _ref3$as = _ref3.as,
    as = _ref3$as === void 0 ? 'p' : _ref3$as,
    className = _ref3.className,
    _ref3$dataAttributes = _ref3.dataAttributes,
    dataAttributes = _ref3$dataAttributes === void 0 ? {} : _ref3$dataAttributes,
    innerRef = _ref3.innerRef,
    children = _ref3.children,
    nativeProps = _objectWithoutProperties__default["default"](_ref3, _excluded3);
  return react.jsx(P3Styled, _extends__default["default"]({}, nativeProps, {
    innerRef: innerRef,
    dataAttributes: dataAttributes,
    variant: variant,
    className: className,
    as: as
  }), children);
};
var P4 = function P4(_ref4) {
  var _ref4$variant = _ref4.variant,
    variant = _ref4$variant === void 0 ? 'regular' : _ref4$variant,
    _ref4$as = _ref4.as,
    as = _ref4$as === void 0 ? 'p' : _ref4$as,
    className = _ref4.className,
    _ref4$dataAttributes = _ref4.dataAttributes,
    dataAttributes = _ref4$dataAttributes === void 0 ? {} : _ref4$dataAttributes,
    innerRef = _ref4.innerRef,
    children = _ref4.children,
    nativeProps = _objectWithoutProperties__default["default"](_ref4, _excluded4);
  return react.jsx(P4Styled, _extends__default["default"]({}, nativeProps, {
    innerRef: innerRef,
    dataAttributes: dataAttributes,
    variant: variant,
    className: className,
    as: as
  }), children);
};
var P5 = function P5(_ref5) {
  var _ref5$variant = _ref5.variant,
    variant = _ref5$variant === void 0 ? 'regular' : _ref5$variant,
    _ref5$as = _ref5.as,
    as = _ref5$as === void 0 ? 'p' : _ref5$as,
    className = _ref5.className,
    _ref5$dataAttributes = _ref5.dataAttributes,
    dataAttributes = _ref5$dataAttributes === void 0 ? {} : _ref5$dataAttributes,
    innerRef = _ref5.innerRef,
    children = _ref5.children,
    nativeProps = _objectWithoutProperties__default["default"](_ref5, _excluded5);
  return react.jsx(P5Styled, _extends__default["default"]({}, nativeProps, {
    innerRef: innerRef,
    dataAttributes: dataAttributes,
    variant: variant,
    className: className,
    as: as
  }), children);
};

exports.P1 = P1;
exports.P2 = P2;
exports.P3 = P3;
exports.P4 = P4;
exports.P5 = P5;
exports.TextContainer = TextContainer;
//# sourceMappingURL=Paragraph-284fa117.js.map
